import React from "react";
import {Outlet} from "react-router-dom";
import Menu from "routes/Menu";

const Activity = () => {
  Menu(3);
  return (
    <>
      <Outlet />
    </>
  );
};

export default Activity;
